import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { NetworkService } from '../services/network.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private networkService: NetworkService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        const server = err.headers.get("server");
        if (server && server !== "matchmaker") {
          this.networkService.startChecking();
        } else if (err.status === 401) {
          // auto logout if 401 response returned from api
          this.authService.signOut();
        }

        const error = (err.error && err.error.message) || (err.message) || `${err.status}: ${err.statusText}`;
        return throwError(error);
      })
    );
  }
}
